import React, {Component} from 'react';

import PaginationV2 from '@app/components/Pagination/V2';

import * as Constant from '@app/Constant.js';


import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


import axios from '@app/lib/axios';

const basePagingInfo = { perPage: 10, maxShowPage: 10 };
class List extends Component {

	constructor(props) {
		super(props);
		this.state= {
			loaded : false,
			doSomething : false,
			list : [],
			page : this.props.page || 0,
			total_cnt: 0,
			type : this.props.type || "user_id",
			keyword : this.props.keyword || "",
			status : this.props.status || ""
		};
	}

    componentDidMount(){    
        this.getList(this.state.page);
    }


	getList = (page) => {
		this.setState(
				{
					loaded : false,
					doSomething : true
				},
				function() {
					axios({
			          method: "get",
			          url: Constant.API_DOMAIN+`/api/tomoplay/parent/list?page=${page}&type=${this.state.type}&keyword=${this.state.keyword}&status=${this.state.status}`
			        })
				    .then(result => {
				        if(result.data.code === 200) {  
							this.setState({
								page : page,
								list : result.data.data.list,
								loaded : true,
								doSomething : false,
								page_start_idx : result.data.data.page_group_start,
								page_finish_idx : result.data.data.page_group_finish,
								last_page : result.data.data.last_page,
								total_cnt: result.data.data.total_cnt,
							});
				        } 
				      })
				      .catch(error => {
				        console.log(error);
				        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
				    });
				    
				}
		);
	}

	goViewPage = (id) => {
		document.location.href = `./parent?view=detail&id=${id}&service=tomoplay&page=${this.state.page}&type=${this.state.type}&keyword=${this.state.keyword}&status=${this.state.status}` ;
	}

	handleChange = (e) => {

        const target = e.target;
        const value = target.value;
        const name = target.name;

        var stateData = {
            [name] : value
        }
        
		if(name === 'status') {
			stateData.page = 0;
			this.setState(stateData, this.getList(0));
		} else this.setState(stateData);
	};


	defaultColDef = {
		headerClass:'bg-dark text-light',
	};
    listColumn = [
    	{
		    headerName: "No",
		    field: "id",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "아이디",
		    field: "user_id",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "휴대폰 번호",
		    field: "mobile",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "이메일",
		    field: "email",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "계정-토모플레이",
		    field: "status",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
		    cellRenderer : (param) => {
		    	if (param.data.status === "deleted") {
					return "탈퇴";
                } else {
                	if(param.data.isLegacy || param.data.agreeTomoplay) {
						return "가입";
					} else {
						return "미가입";	
					}
                }
        	}
		},
		{
		    headerName: "계정-젤링",
		    field: "status",
		    sortable: false,
		    minWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
		    cellRenderer : (param) => {
		    	if (param.data.status === "deleted") {
					return "탈퇴";
                } else {
                	if(param.data.agreeJelliing) {
						return "가입";
					} else {
						return "미가입";	
					}
                }
        	}
		},
		{
		    headerName: "가입일",
		    field: "createDate",
		    sortable: false,
		    maxWidth : 170,
		    resizable : false,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "최근 접속일",
		    field: "lastLoginDate",
		    sortable: false,
		    maxWidth : 170,
		    resizable : false,
		    cellClass: "text-center",
		    filter: false
		},
	];


	onGridReady = params => {
		this.gridApi = params.api;
        params.api.sizeColumnsToFit();
    }

    rowClick = (agGrid) => {
    	document.location.href = "/service/manage/parent?view=detail&service=tomoplay&id=" + agGrid.api.selectionController.lastSelectedNode.data.id;
    }

	render() {
		
		if (this.state.loaded) {
			return (	
				<div className="card border-top">
					<div className="card-body">
						<div className="row" style={{marginBottom : "20px"}}>
							<div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
								<label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="" checked={this.state.status === ""} className="custom-control-input" onChange={this.handleChange}/>
                                    <span className="custom-control-label">전체</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="join" checked={this.state.status === "join"} className="custom-control-input" onChange={this.handleChange}/>
                                    <span className="custom-control-label">가입</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="deleted" checked={this.state.status === "deleted"} className="custom-control-input" onChange={this.handleChange}/>
                                    <span className="custom-control-label">탈퇴</span> 
                                </label>
							</div>
							<div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
								<div className="input-group my-group input-group" >
									<select name="type" className="form-control input-group-append" title="검색 항목 선택" value={this.state.type} style={{height: "auto", maxWidth: "130px"}} onChange={this.handleChange}>
										<option value="user_id">ID</option>
										<option value="mobile">휴대전화 번호</option>
										<option value="email">이메일</option>
									</select>
									<input className="form-control" type="text" name="keyword" value={this.state.keyword} onChange={this.handleChange} placeholder="키워드 입력" style={{minWidth : "200px"}}/>
									<div className="input-group-append">
										<button type="button" className="btn btn-primary btn btn-primary" onClick={() => this.getList(0)} disabled={this.state.doSomething}>검색</button>
									</div>
								</div>
							</div>

						</div>
						<div className="row">
							<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{height : "440px"}}>
								<AgGridReact
								  onGridReady={this.onGridReady}
								  defaultColDef={this.defaultColDef}
						          columnDefs={this.listColumn}
						          rowData={this.state.list}	
						          rowHeight={40}
						          rowSelection='single'
						          onSelectionChanged={this.rowClick.bind(this)}
						        />
						        
							</div>
						</div>
						<div className="row" style={{marginTop : "10px"}}>
							<div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                        		<PaginationV2 perPage={basePagingInfo.perPage} maxShowPage={basePagingInfo.maxShowPage} currentPage={Number(this.state.page)} total={this.state.total_cnt} callback={this.getList} disabled={this.state.doSomething} />
							</div>
							<div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-2">
								
							</div>
						</div>
					</div>
				</div>
			)
        } else {
        	return (
                <div className="card border-top">
                    <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", padding:"50px"}}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            )
        }
		
		
	}
};

export default List ;